import { styled, typography } from '@pulse-web-ui/theme';

export const Wrapper = styled.p`
  ${typography.regular14};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  line-height: 20px;
  white-space: pre-line;
`;
